import { useContext } from "react";
import { ValidationResult } from "sprint-common-web";

import { AppConfigContext } from "../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../core/data-access/useAuthorizedFetch";
import { GetOrderRequestDetailsRequest } from "./order-request/GetOrderRequestDetailsRequest";
import { GetOrderRequestDetailsResponse } from "./order-request/GetOrderRequestDetailsResponse";
import { GetOrderRequestListRequest } from "./order-request/GetOrderRequestListRequest";
import { GetOrderRequestListResponse } from "./order-request/GetOrderRequestListResponse";
import { MoveOrderRequestToPendingRequest } from "./order-request/MoveOrderRequestToPendingRequest";
import { RefreshOrderRequestRequest } from "./order-request/RefreshOrderRequestRequest";
import { ValidateMoveOrderRequestToPendingRequest } from "./order-request/ValidateMoveOrderRequestToPendingRequest";

export const useOrdersRequestsApi = () => {
    const { httpPut, httpGet } = useAuthorizedFetch();
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/order-requests`;

    const getOrderRequestList = async (request: GetOrderRequestListRequest): Promise<GetOrderRequestListResponse> =>
        httpGet<GetOrderRequestListResponse>(`${baseUrl}/list`, request);

    const refreshOrderRequest = async (request: RefreshOrderRequestRequest): Promise<void> =>
        httpPut(`${baseUrl}/refresh`, request);

    const moveOrderRequestToPending = async (request: MoveOrderRequestToPendingRequest): Promise<void> =>
        httpPut(`${baseUrl}/move-to-pending`, request);

    const validateMoveOrderRequestToPending = async (
        request: ValidateMoveOrderRequestToPendingRequest
    ): Promise<ValidationResult> => httpGet(`${baseUrl}/validate-move-to-pending`, request);

    const getOrderRequestDetails = async (
        request: GetOrderRequestDetailsRequest
    ): Promise<GetOrderRequestDetailsResponse> =>
        httpGet<GetOrderRequestDetailsResponse>(`${baseUrl}/details`, request);

    return {
        getOrderRequestList,
        moveOrderRequestToPending,
        validateMoveOrderRequestToPending,
        refreshOrderRequest,
        getOrderRequestDetails
    };
};
